import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Stack,
} from '@mui/material';

import { Icon } from '@components/base';
import useSubscriber from '@hooks/useSubscriber';

const ChooseAddressDialog: FC = () => {
  const { t } = useTranslation();

  const { profileOptions, handleSelectProfile, cancelLogin } = useSubscriber();

  return profileOptions ? (
    <Dialog fullWidth maxWidth='xs' onClose={cancelLogin} open>
      <DialogTitle>{t('subscriber.login.chooseAddress')}</DialogTitle>

      <Box component={DialogContent} pt={0}>
        <Stack component={MenuList} spacing={1.5}>
          {profileOptions.map(({ subscriberId, address }) => (
            <Card
              component={MenuItem}
              key={subscriberId}
              onClick={() => handleSelectProfile(subscriberId)}
            >
              <ListItemIcon>
                <Icon fontSize='small' name='subscriber' />
              </ListItemIcon>

              <ListItemText primary={address} secondary={subscriberId} />
            </Card>
          ))}
        </Stack>
      </Box>
    </Dialog>
  ) : null;
};

export default ChooseAddressDialog;
